"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateEventVersion = exports.BuilderConfigStatuses = exports.SweepstakesRulesTypes = exports.PostShowEmailCTATypes = exports.PostShowEmailTypes = exports.PolicyEntities = exports.PostRegistationOptions = exports.VoteTypeOptions = exports.CheckInVoteOptions = exports.Languages = exports.getSocialLinks = exports.StreamingServiceNames = exports.generatePostRegText = exports.generatePreRegText = void 0;
const event_1 = require("../event");
const utils_1 = require("../utils");
const postregistration_1 = require("./postregistration");
const preregistration_1 = require("./preregistration");
const privacy_1 = require("./privacy");
const colors_1 = require("./colors");
const generateBuilderConfig_1 = require("./generateBuilderConfig");
var preregistration_2 = require("./preregistration");
Object.defineProperty(exports, "generatePreRegText", { enumerable: true, get: function () { return preregistration_2.generatePreRegText; } });
var postregistration_2 = require("./postregistration");
Object.defineProperty(exports, "generatePostRegText", { enumerable: true, get: function () { return postregistration_2.generatePostRegText; } });
__exportStar(require("./colors"), exports);
__exportStar(require("./generateBuilderConfig"), exports);
__exportStar(require("./privacy"), exports);
// From spotify
/**
 * - album
 * - single
 * - appears_on (ignore??)
 * - compilation (ignore??)
 */
exports.StreamingServiceNames = [
    { path: "appleMusic", name: "Apple Music" },
    { path: "amazon", name: "Amazon Music" },
    { path: "pandora", name: "Pandora" },
    { path: "spotify", name: "Spotify" },
    { path: "youtubeMusic", name: "YouTube Music" },
    { path: "deezer", name: "Deezer" },
    { path: "iHeartRadio", name: "iHeartRadio" },
    { path: "tidal", name: "Tidal" },
];
/**
 * Extracts social links from bulder config doc.
 */
const getSocialLinks = (config) => {
    const getSocialKey = (key) => {
        var _a;
        const { name } = ((_a = key.match(/socialLink(?<name>.*)/)) === null || _a === void 0 ? void 0 : _a.groups) || {};
        if (name) {
            if (event_1.SocialLinkNames.includes(name.toLowerCase())) {
                return name.toLowerCase();
            }
        }
    };
    return Object.fromEntries(Object.entries(config.fields || {})
        .map(([key, value]) => {
        const k = getSocialKey(key);
        value.content;
        if (k && typeof value.content === "string") {
            return [k, value.content];
        }
        return undefined;
    })
        .filter(utils_1.filterUndefined));
};
exports.getSocialLinks = getSocialLinks;
exports.Languages = {
    es: "Spanish",
    fr: "French",
    de: "German",
};
exports.CheckInVoteOptions = ["checkin", "vote"];
exports.VoteTypeOptions = ["song", "vote"];
exports.PostRegistationOptions = ["thank", "promo", "link"];
exports.PolicyEntities = [
    { path: "artist", name: "Artist" },
    { path: "management", name: "Management" },
    { path: "recordLabel", name: "Record Label" },
    { path: "marketing", name: "Marketing" },
    { path: "other", name: "Other" },
];
exports.PostShowEmailTypes = [
    "disabled",
    "default",
    "custom",
    "html",
];
exports.PostShowEmailCTATypes = ["survey", "custom", "disabled"];
exports.SweepstakesRulesTypes = ["default", "link", "html"];
exports.BuilderConfigStatuses = [
    "created",
    "draft",
    "publish_requested",
    "published",
];
/**
 * Check to see if the provided object is a Luxon DateTime instance.
 */
const isDateTime = (maybeDateTime) => {
    const d = Object.getOwnPropertyDescriptor(maybeDateTime, "isLuxonDateTime");
    return (d === null || d === void 0 ? void 0 : d.value) === true;
};
/**
 * Generate a SETLive fan config document.
 */
const generateEventVersion = (config, { language = "en", demoConfig, props, Timestamp, }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56, _57, _58, _59, _60, _61, _62, _63, _64, _65, _66, _67, _68, _69, _70, _71, _72, _73, _74, _75, _76, _77, _78, _79, _80, _81, _82, _83, _84, _85, _86, _87, _88, _89, _90;
    const postRegText = (0, postregistration_1.generatePostRegText)(config);
    const { preRegText } = (0, preregistration_1.generatePreRegText)(config);
    //
    // TODO: Make translatable
    //
    const { sms, terms, separateTerms } = (0, privacy_1.generatePrivacyText)(config, language);
    const getTimestamp = (dateThingy) => {
        if (isDateTime(dateThingy)) {
            return Timestamp.fromDate(dateThingy.toJSDate());
        }
        return dateThingy;
    };
    const disableDefaultCopy = !!(props === null || props === void 0 ? void 0 : props.override.disableDefaultCopy);
    const image = ((_b = (_a = config === null || config === void 0 ? void 0 : config.fields) === null || _a === void 0 ? void 0 : _a.image) === null || _b === void 0 ? void 0 : _b.content) ||
        ((_d = (_c = config === null || config === void 0 ? void 0 : config.images) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.src) ||
        (demoConfig === null || demoConfig === void 0 ? void 0 : demoConfig.header.image);
    const { imageColors, imageIndex } = (0, colors_1.getColorConfig)(config);
    const date = ((_f = (_e = config.fields) === null || _e === void 0 ? void 0 : _e.startTime) === null || _f === void 0 ? void 0 : _f.content)
        ? getTimestamp(config.fields.startTime.content)
        : demoConfig === null || demoConfig === void 0 ? void 0 : demoConfig.header.date;
    const type = ((_g = props === null || props === void 0 ? void 0 : props.override) === null || _g === void 0 ? void 0 : _g.type) !== undefined
        ? (_h = props === null || props === void 0 ? void 0 : props.override) === null || _h === void 0 ? void 0 : _h.type
        : ((_k = (_j = config.fields) === null || _j === void 0 ? void 0 : _j.type) === null || _k === void 0 ? void 0 : _k.content) || 0;
    const colors = ((_l = props === null || props === void 0 ? void 0 : props.override) === null || _l === void 0 ? void 0 : _l.colors) ||
        ((_q = (_p = (_o = (_m = config.fields) === null || _m === void 0 ? void 0 : _m.colors) === null || _o === void 0 ? void 0 : _o.content) === null || _p === void 0 ? void 0 : _p[imageIndex]) === null || _q === void 0 ? void 0 : _q[type]) ||
        ((_r = imageColors === null || imageColors === void 0 ? void 0 : imageColors[type]) === null || _r === void 0 ? void 0 : _r[0]);
    if (!config.fields ||
        ((_t = (_s = config.fields) === null || _s === void 0 ? void 0 : _s.type) === null || _t === void 0 ? void 0 : _t.content) === undefined ||
        !image ||
        !date ||
        !colors) {
        throw new Error("TODO: Handle this");
    }
    if (disableDefaultCopy) {
        preRegText.headline = "";
        preRegText.subtitle = "";
        preRegText.body = "";
        postRegText.headline = "";
        postRegText.body = "";
    }
    const register = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, demoConfig === null || demoConfig === void 0 ? void 0 : demoConfig.register), (_u = config.customRegister) === null || _u === void 0 ? void 0 : _u[language]), { title: (_w = (_v = config.fields.registerTitle) === null || _v === void 0 ? void 0 : _v.content) === null || _w === void 0 ? void 0 : _w[language], subtitle: (_y = (_x = config.fields.registerSubtitle) === null || _x === void 0 ? void 0 : _x.content) === null || _y === void 0 ? void 0 : _y[language], ctalabel: ((_0 = (_z = config.fields.registerCtaLabel) === null || _z === void 0 ? void 0 : _z.content) === null || _0 === void 0 ? void 0 : _0[language]) ||
            (((_2 = (_1 = config === null || config === void 0 ? void 0 : config.fields) === null || _1 === void 0 ? void 0 : _1.checkInVote) === null || _2 === void 0 ? void 0 : _2.content) === "vote" ? "Vote" : "Check In"), sms,
        terms }), (!((_3 = config.fields.useCustomTermsAndPrivacyPolicy) === null || _3 === void 0 ? void 0 : _3.content)
        ? Object.assign(Object.assign({}, (!!(separateTerms === null || separateTerms === void 0 ? void 0 : separateTerms.length) && {
            customTerms: separateTerms[0],
        })), ((separateTerms === null || separateTerms === void 0 ? void 0 : separateTerms.length) &&
            separateTerms.length > 1 && {
            customAgreement: separateTerms[1],
        })) : {
        terms: (_5 = (_4 = config.fields.customTermsAndPrivacyPolicy) === null || _4 === void 0 ? void 0 : _4.content) === null || _5 === void 0 ? void 0 : _5[language],
        customTerms: (_7 = (_6 = config.fields.separateLineTermsAndPrivacyPolicy) === null || _6 === void 0 ? void 0 : _6.content) === null || _7 === void 0 ? void 0 : _7[language],
    })), (((_8 = config.fields.useCustomSMSOptIn) === null || _8 === void 0 ? void 0 : _8.content) && {
        sms: (_10 = (_9 = config.fields.customSMSOptIn) === null || _9 === void 0 ? void 0 : _9.content) === null || _10 === void 0 ? void 0 : _10[language],
    })), { hasSweepstakes: (_11 = config.fields.sweepstakes) === null || _11 === void 0 ? void 0 : _11.content }), (((_12 = config.fields.sweepstakesRulesType) === null || _12 === void 0 ? void 0 : _12.content) === "html" && {
        customSweepstakesRules: (_13 = config.fields.sweepstakesRulesHtml) === null || _13 === void 0 ? void 0 : _13.content,
    })), (((_14 = config.fields.sweepstakesRulesType) === null || _14 === void 0 ? void 0 : _14.content) === "link" && {
        customSweepstakesRules: `<p style="text-align:center;padding:24px;"><a style="color:#1B0076;font-weight:500;" href="https://rules.set.live/${(_15 = config.fields.sweepstakesRulesLink) === null || _15 === void 0 ? void 0 : _15.content}" target="_blank">Click here for the Official Rules</a></p>`,
    })), { optionalSms: !!((_16 = config.fields.makeTextMessageOptInOptional) === null || _16 === void 0 ? void 0 : _16.content), optionalPhone: !!((_17 = config.fields.makePhoneNumberFieldOptional) === null || _17 === void 0 ? void 0 : _17.content) });
    const fanConfig = Object.assign(Object.assign({}, demoConfig), { type, header: Object.assign(Object.assign({}, demoConfig === null || demoConfig === void 0 ? void 0 : demoConfig.header), { artistName: ((_19 = (_18 = config === null || config === void 0 ? void 0 : config.fields) === null || _18 === void 0 ? void 0 : _18.displayedName) === null || _19 === void 0 ? void 0 : _19.content) || config.artistName || "", date,
            image, venue: (_21 = (_20 = config.fields.concert) === null || _20 === void 0 ? void 0 : _20.content) === null || _21 === void 0 ? void 0 : _21.venue }), cards: [
            Object.assign({ cta: "register", visible: {
                    states: [event_1.UserEventStates.draft],
                }, headline: ((_23 = (_22 = config.fields.preRegistrationHeadline) === null || _22 === void 0 ? void 0 : _22.content) === null || _23 === void 0 ? void 0 : _23[language]) ||
                    preRegText.headline }, (((_24 = config.fields.checkInVote) === null || _24 === void 0 ? void 0 : _24.content) === "vote"
                ? Object.assign({ 
                    // Voting
                    tab: "Vote", subtitle: ((_26 = (_25 = config.fields.preRegistrationSubtitle) === null || _25 === void 0 ? void 0 : _25.content) === null || _26 === void 0 ? void 0 : _26[language]) ||
                        preRegText.subtitle }, (((_27 = config.fields.voteType) === null || _27 === void 0 ? void 0 : _27.content) === "song"
                    ? {
                        // Songs
                        songs: (_30 = (_29 = (_28 = config.fields.songOptions) === null || _28 === void 0 ? void 0 : _28.content) === null || _29 === void 0 ? void 0 : _29.filter((song) => !!song.name)) === null || _30 === void 0 ? void 0 : _30.map((s) => ({
                            id: s.name + s.album || "",
                            title: s.name || "",
                            album: s.album || "",
                        })),
                    }
                    : {
                        // Something else
                        songs: (_33 = (_32 = (_31 = config.fields.voteOptions) === null || _31 === void 0 ? void 0 : _31.content) === null || _32 === void 0 ? void 0 : _32.filter((option) => !!(option === null || option === void 0 ? void 0 : option[language]))) === null || _33 === void 0 ? void 0 : _33.map((s) => ({
                            id: (s === null || s === void 0 ? void 0 : s[language]) || "",
                            title: (s === null || s === void 0 ? void 0 : s[language]) || "",
                        })),
                    })) : Object.assign({ 
                // Check In
                tab: "Check In", ctalabel: "Check In", body: ((_35 = (_34 = config.fields.preRegistrationBody) === null || _34 === void 0 ? void 0 : _34.content) === null || _35 === void 0 ? void 0 : _35[language]) ||
                    preRegText.body }, (((_37 = (_36 = config.fields.preRegistrationButtonLabel) === null || _36 === void 0 ? void 0 : _36.content) === null || _37 === void 0 ? void 0 : _37[language]) && {
                ctalabel: (_39 = (_38 = config.fields.preRegistrationButtonLabel) === null || _38 === void 0 ? void 0 : _38.content) === null || _39 === void 0 ? void 0 : _39[language],
            })))),
        ], colors: colors, register, social: {
            title: `${(_41 = (_40 = config.fields.postRegistrationButtonLabel) === null || _40 === void 0 ? void 0 : _40.content) === null || _41 === void 0 ? void 0 : _41[language]} ${(_43 = (_42 = config.fields.postRegistrationAlbum) === null || _42 === void 0 ? void 0 : _42.content) === null || _43 === void 0 ? void 0 : _43.name} on your favorite streaming service.`,
            // subtitle: "available on:", this field not in use
            spotify: (_45 = (_44 = config.fields.postRegistrationAlbum) === null || _44 === void 0 ? void 0 : _44.content) === null || _45 === void 0 ? void 0 : _45.spotify,
            apple: (_47 = (_46 = config.fields.postRegistrationAlbum) === null || _46 === void 0 ? void 0 : _46.content) === null || _47 === void 0 ? void 0 : _47.appleMusic,
            amazon: (_49 = (_48 = config.fields.postRegistrationAlbum) === null || _48 === void 0 ? void 0 : _48.content) === null || _49 === void 0 ? void 0 : _49.amazon,
            deezer: (_51 = (_50 = config.fields.postRegistrationAlbum) === null || _50 === void 0 ? void 0 : _50.content) === null || _51 === void 0 ? void 0 : _51.deezer,
            youtube: (_53 = (_52 = config.fields.postRegistrationAlbum) === null || _52 === void 0 ? void 0 : _52.content) === null || _53 === void 0 ? void 0 : _53.youtubeMusic,
            pandora: (_55 = (_54 = config.fields.postRegistrationAlbum) === null || _54 === void 0 ? void 0 : _54.content) === null || _55 === void 0 ? void 0 : _55.pandora,
            tidal: (_57 = (_56 = config.fields.postRegistrationAlbum) === null || _56 === void 0 ? void 0 : _56.content) === null || _57 === void 0 ? void 0 : _57.tidal,
        }, socialLinks: {
            facebook: (_58 = config.fields.socialLinkFacebook) === null || _58 === void 0 ? void 0 : _58.content,
            instagram: (_59 = config.fields.socialLinkInstagram) === null || _59 === void 0 ? void 0 : _59.content,
            tiktok: (_60 = config.fields.socialLinkTiktok) === null || _60 === void 0 ? void 0 : _60.content,
            spotify: (_61 = config.fields.socialLinkSpotify) === null || _61 === void 0 ? void 0 : _61.content,
            youtube: (_62 = config.fields.socialLinkYoutube) === null || _62 === void 0 ? void 0 : _62.content,
            twitter: (_63 = config.fields.socialLinkTwitter) === null || _63 === void 0 ? void 0 : _63.content,
            shazam: (_64 = config.fields.socialLinkShazam) === null || _64 === void 0 ? void 0 : _64.content,
        } });
    // Post registration view
    if (fanConfig.cards) {
        fanConfig.cards.push(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ tab: fanConfig.cards[0].tab }, postRegText), { headline: ((_66 = (_65 = config.fields.postRegistrationHeadline) === null || _65 === void 0 ? void 0 : _65.content) === null || _66 === void 0 ? void 0 : _66[language]) ||
                postRegText.headline, body: ((_68 = (_67 = config.fields.postRegistrationBody) === null || _67 === void 0 ? void 0 : _67.content) === null || _68 === void 0 ? void 0 : _68[language]) ||
                postRegText.body }), (((_69 = config.fields.postRegistration) === null || _69 === void 0 ? void 0 : _69.content) === "promo" && {
            image: (_72 = (_71 = (_70 = config === null || config === void 0 ? void 0 : config.fields) === null || _70 === void 0 ? void 0 : _70.postRegistrationAlbum) === null || _71 === void 0 ? void 0 : _71.content) === null || _72 === void 0 ? void 0 : _72.image,
            ctalabel: ((_74 = (_73 = config.fields.postRegistrationButtonLabel) === null || _73 === void 0 ? void 0 : _73.content) === null || _74 === void 0 ? void 0 : _74[language]) ||
                postRegText.ctalabel,
            cta: "social",
        })), (((_75 = config.fields.postRegistration) === null || _75 === void 0 ? void 0 : _75.content) === "link" && {
            cta: ((_76 = config.fields.postRegistrationLinkUrl) === null || _76 === void 0 ? void 0 : _76.content) || postRegText.cta,
            ctalabel: ((_78 = (_77 = config.fields.postRegistrationLinkLabel) === null || _77 === void 0 ? void 0 : _77.content) === null || _78 === void 0 ? void 0 : _78[language]) ||
                postRegText.ctalabel,
        })), { visible: {
                states: [event_1.UserEventStates.draft],
                hide: true,
            } }));
    }
    // Merch View
    const merchTabName = !((_79 = config.fields.useCustomMerchTabName) === null || _79 === void 0 ? void 0 : _79.content)
        ? "Merch"
        : (_81 = (_80 = config.fields.customMerchTabName) === null || _80 === void 0 ? void 0 : _80.content) === null || _81 === void 0 ? void 0 : _81[language];
    if (!((_82 = config.fields.hideMerchandise) === null || _82 === void 0 ? void 0 : _82.content) &&
        !!((_84 = (_83 = config.fields.merchandise) === null || _83 === void 0 ? void 0 : _83.content) === null || _84 === void 0 ? void 0 : _84.length) &&
        fanConfig.cards) {
        fanConfig.cards.push(Object.assign(Object.assign({ tab: merchTabName }, (fanConfig.type === 0 && {
            headline: merchTabName,
            icon: "shirt",
        })), { merch: (_86 = (_85 = config.fields.merchandise) === null || _85 === void 0 ? void 0 : _85.content) === null || _86 === void 0 ? void 0 : _86.reduce((acc, m) => {
                if (m.isSelected) {
                    acc.push(Object.assign(Object.assign({}, m), { photo: m.img, name: m.text }));
                }
                return acc;
            }, []) }));
    }
    // If swiper, add icons to pre & post registration cards
    if (fanConfig.type === 0 && fanConfig.cards) {
        fanConfig.cards[0].icon =
            ((_87 = config.fields.checkInVote) === null || _87 === void 0 ? void 0 : _87.content) === "vote" ? "checklist" : "user";
        fanConfig.cards[1].icon = "checkmark";
    }
    const country = (0, generateBuilderConfig_1.getAddressComponent)("country", (_90 = (_89 = (_88 = config.fields.concert) === null || _88 === void 0 ? void 0 : _88.content) === null || _89 === void 0 ? void 0 : _89.geocode) === null || _90 === void 0 ? void 0 : _90.address_components);
    if (!!country) {
        fanConfig.meta = {
            country: country,
        };
    }
    return (0, utils_1.removeUndefined)(fanConfig);
};
exports.generateEventVersion = generateEventVersion;
//# sourceMappingURL=index.js.map